import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { homeRoute } from "../routes/routesPath";
import { OverlayLoader } from "../Component/Loader";
import { getMyAccountPagePath } from "../utils/helpers";

export function AuthRoute() {
  const authData = useAuth();
  const navigate = useNavigate();

  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    setIsAuthChecked(true);
    if (authData.isAuthenticated) {
      navigate(getMyAccountPagePath(), { replace: true });
    }

    return () => setIsAuthChecked(false);
  }, [authData]);

  return isAuthChecked ? <Outlet /> : <OverlayLoader />;
}

export function PrivateRoute() {
  const authData = useAuth();
  const navigate = useNavigate();

  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    setIsAuthChecked(true);
    if (!authData.isAuthenticated) {
      navigate(homeRoute, { replace: true });
    }

    return () => setIsAuthChecked(false);
  }, [authData]);

  return isAuthChecked ? <Outlet /> : <OverlayLoader />;
}
